import { render, staticRenderFns } from "./pc-form-tabs.vue?vue&type=template&id=7592f7e4&scoped=true&"
import script from "./pc-form-tabs.vue?vue&type=script&lang=ts&"
export * from "./pc-form-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./pc-form-tabs.vue?vue&type=style&index=0&id=7592f7e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7592f7e4",
  null
  
)

export default component.exports